const selectDeviceStatuses = state => state.data.deviceStatuses

const DeviceStatusDataStoreSelectors = {
  deviceStatuses: selectDeviceStatuses
}

export default DeviceStatusDataStoreSelectors
